var map = {
	"./11.webp": 1107,
	"./2.webp": 1685,
	"./IMG_4854-min.webp": 4661,
	"./IMG_4872-min.webp": 5621,
	"./IMG_6770-min.webp": 5924,
	"./IMG_7410-min.webp": 726,
	"./IMG_7412-min.webp": 9852
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2629;